/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Method_Content_Step_05_Detail_Tournament_0_HeadingInputs */

const en_method_content_step_05_detail_tournament_0_heading = /** @type {(inputs: Method_Content_Step_05_Detail_Tournament_0_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Angular momentum transfer`)
};

const es_method_content_step_05_detail_tournament_0_heading = /** @type {(inputs: Method_Content_Step_05_Detail_Tournament_0_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Transferencia de momento angular`)
};

const de_method_content_step_05_detail_tournament_0_heading = /** @type {(inputs: Method_Content_Step_05_Detail_Tournament_0_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Drehimpulsübertragung`)
};

const zh_method_content_step_05_detail_tournament_0_heading = /** @type {(inputs: Method_Content_Step_05_Detail_Tournament_0_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`角动量传递`)
};

const ar_method_content_step_05_detail_tournament_0_heading = /** @type {(inputs: Method_Content_Step_05_Detail_Tournament_0_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`نقل الزخم الزاوي`)
};

const fr_method_content_step_05_detail_tournament_0_heading = /** @type {(inputs: Method_Content_Step_05_Detail_Tournament_0_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Transfert de moment angulaire`)
};

const vi_method_content_step_05_detail_tournament_0_heading = /** @type {(inputs: Method_Content_Step_05_Detail_Tournament_0_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Truyền động lượng góc`)
};

const sw_method_content_step_05_detail_tournament_0_heading = /** @type {(inputs: Method_Content_Step_05_Detail_Tournament_0_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Uhamishaji wa momentamu ya mzunguko`)
};

const th_method_content_step_05_detail_tournament_0_heading = /** @type {(inputs: Method_Content_Step_05_Detail_Tournament_0_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`การถ่ายทอดโมเมนตัมเชิงมุม`)
};

const bs_method_content_step_05_detail_tournament_0_heading = /** @type {(inputs: Method_Content_Step_05_Detail_Tournament_0_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Prenos ugaonog momenta`)
};

const ja_method_content_step_05_detail_tournament_0_heading = /** @type {(inputs: Method_Content_Step_05_Detail_Tournament_0_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`角運動量の伝達`)
};

const ko_method_content_step_05_detail_tournament_0_heading = /** @type {(inputs: Method_Content_Step_05_Detail_Tournament_0_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`각운동량의 전달`)
};

const pt_method_content_step_05_detail_tournament_0_heading = /** @type {(inputs: Method_Content_Step_05_Detail_Tournament_0_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Transferência de momento angular`)
};

const it_method_content_step_05_detail_tournament_0_heading = /** @type {(inputs: Method_Content_Step_05_Detail_Tournament_0_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Trasferimento del momento angolare`)
};

const sv_method_content_step_05_detail_tournament_0_heading = /** @type {(inputs: Method_Content_Step_05_Detail_Tournament_0_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Överföring av rörelsemängdsmoment`)
};

const nl_method_content_step_05_detail_tournament_0_heading = /** @type {(inputs: Method_Content_Step_05_Detail_Tournament_0_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Overdracht van hoekimpuls`)
};

const da_method_content_step_05_detail_tournament_0_heading = /** @type {(inputs: Method_Content_Step_05_Detail_Tournament_0_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Overførsel af impulsmoment`)
};

const nb_method_content_step_05_detail_tournament_0_heading = /** @type {(inputs: Method_Content_Step_05_Detail_Tournament_0_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Overføring av impulsmoment`)
};

const fi_method_content_step_05_detail_tournament_0_heading = /** @type {(inputs: Method_Content_Step_05_Detail_Tournament_0_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kulmaliikemäärän siirto`)
};

const pl_method_content_step_05_detail_tournament_0_heading = /** @type {(inputs: Method_Content_Step_05_Detail_Tournament_0_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Przekazywanie momentu pędu`)
};

const ru_method_content_step_05_detail_tournament_0_heading = /** @type {(inputs: Method_Content_Step_05_Detail_Tournament_0_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Передача момента импульса`)
};

const tr_method_content_step_05_detail_tournament_0_heading = /** @type {(inputs: Method_Content_Step_05_Detail_Tournament_0_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Açısal momentum aktarımı`)
};

const hi_method_content_step_05_detail_tournament_0_heading = /** @type {(inputs: Method_Content_Step_05_Detail_Tournament_0_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`कोणीय संवेग का हस्तांतरण`)
};

const id_method_content_step_05_detail_tournament_0_heading = /** @type {(inputs: Method_Content_Step_05_Detail_Tournament_0_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Transfer momentum sudut`)
};

const ms_method_content_step_05_detail_tournament_0_heading = /** @type {(inputs: Method_Content_Step_05_Detail_Tournament_0_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pemindahan momentum sudut`)
};

const cs_method_content_step_05_detail_tournament_0_heading = /** @type {(inputs: Method_Content_Step_05_Detail_Tournament_0_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Přenos momentu hybnosti`)
};

const el_method_content_step_05_detail_tournament_0_heading = /** @type {(inputs: Method_Content_Step_05_Detail_Tournament_0_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Μεταφορά γωνιακής ορμής`)
};

const he_method_content_step_05_detail_tournament_0_heading = /** @type {(inputs: Method_Content_Step_05_Detail_Tournament_0_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`העברת תנע זוויתי`)
};

const af_method_content_step_05_detail_tournament_0_heading = /** @type {(inputs: Method_Content_Step_05_Detail_Tournament_0_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hoekmomentum-oordrag`)
};

const hu_method_content_step_05_detail_tournament_0_heading = /** @type {(inputs: Method_Content_Step_05_Detail_Tournament_0_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`A perdület átadása`)
};

/**
* | output |
* | --- |
* | "Angular momentum transfer" |
*
* @param {Method_Content_Step_05_Detail_Tournament_0_HeadingInputs} inputs
* @param {{ locale?: "en" | "es" | "de" | "zh" | "ar" | "fr" | "vi" | "sw" | "th" | "bs" | "ja" | "ko" | "pt" | "it" | "sv" | "nl" | "da" | "nb" | "fi" | "pl" | "ru" | "tr" | "hi" | "id" | "ms" | "cs" | "el" | "he" | "af" | "hu" }} options
* @returns {LocalizedString}
*/
export const method_content_step_05_detail_tournament_0_heading = /** @type {((inputs?: Method_Content_Step_05_Detail_Tournament_0_HeadingInputs, options?: { locale?: "en" | "es" | "de" | "zh" | "ar" | "fr" | "vi" | "sw" | "th" | "bs" | "ja" | "ko" | "pt" | "it" | "sv" | "nl" | "da" | "nb" | "fi" | "pl" | "ru" | "tr" | "hi" | "id" | "ms" | "cs" | "el" | "he" | "af" | "hu" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Method_Content_Step_05_Detail_Tournament_0_HeadingInputs, { locale?: "en" | "es" | "de" | "zh" | "ar" | "fr" | "vi" | "sw" | "th" | "bs" | "ja" | "ko" | "pt" | "it" | "sv" | "nl" | "da" | "nb" | "fi" | "pl" | "ru" | "tr" | "hi" | "id" | "ms" | "cs" | "el" | "he" | "af" | "hu" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_method_content_step_05_detail_tournament_0_heading(inputs)
	if (locale === "de") return de_method_content_step_05_detail_tournament_0_heading(inputs)
	if (locale === "zh") return zh_method_content_step_05_detail_tournament_0_heading(inputs)
	if (locale === "ar") return ar_method_content_step_05_detail_tournament_0_heading(inputs)
	if (locale === "fr") return fr_method_content_step_05_detail_tournament_0_heading(inputs)
	if (locale === "vi") return vi_method_content_step_05_detail_tournament_0_heading(inputs)
	if (locale === "sw") return sw_method_content_step_05_detail_tournament_0_heading(inputs)
	if (locale === "th") return th_method_content_step_05_detail_tournament_0_heading(inputs)
	if (locale === "bs") return bs_method_content_step_05_detail_tournament_0_heading(inputs)
	if (locale === "ja") return ja_method_content_step_05_detail_tournament_0_heading(inputs)
	if (locale === "ko") return ko_method_content_step_05_detail_tournament_0_heading(inputs)
	if (locale === "pt") return pt_method_content_step_05_detail_tournament_0_heading(inputs)
	if (locale === "it") return it_method_content_step_05_detail_tournament_0_heading(inputs)
	if (locale === "sv") return sv_method_content_step_05_detail_tournament_0_heading(inputs)
	if (locale === "nl") return nl_method_content_step_05_detail_tournament_0_heading(inputs)
	if (locale === "da") return da_method_content_step_05_detail_tournament_0_heading(inputs)
	if (locale === "nb") return nb_method_content_step_05_detail_tournament_0_heading(inputs)
	if (locale === "fi") return fi_method_content_step_05_detail_tournament_0_heading(inputs)
	if (locale === "pl") return pl_method_content_step_05_detail_tournament_0_heading(inputs)
	if (locale === "ru") return ru_method_content_step_05_detail_tournament_0_heading(inputs)
	if (locale === "tr") return tr_method_content_step_05_detail_tournament_0_heading(inputs)
	if (locale === "hi") return hi_method_content_step_05_detail_tournament_0_heading(inputs)
	if (locale === "id") return id_method_content_step_05_detail_tournament_0_heading(inputs)
	if (locale === "ms") return ms_method_content_step_05_detail_tournament_0_heading(inputs)
	if (locale === "cs") return cs_method_content_step_05_detail_tournament_0_heading(inputs)
	if (locale === "el") return el_method_content_step_05_detail_tournament_0_heading(inputs)
	if (locale === "he") return he_method_content_step_05_detail_tournament_0_heading(inputs)
	if (locale === "af") return af_method_content_step_05_detail_tournament_0_heading(inputs)
	if (locale === "hu") return hu_method_content_step_05_detail_tournament_0_heading(inputs)
	return en_method_content_step_05_detail_tournament_0_heading(inputs)
});